import PropTypes from 'prop-types';
import React from 'react';
import { ReactMultiEmail } from 'react-multi-email';

import 'react-multi-email/style.css';
import '../../App.css';
import { Form } from '../UI';

class FeaturePicker extends React.Component {
  state = {
    flags: [],
  };

  handleSubmit = () => {
    const { flags } = this.state;
    const { onComplete } = this.props;
    onComplete(flags);
  }

  render() {
    const { flags } = this.state;

    return (
      <div className="app-status">
        <Form button="Continue" onSubmit={this.handleSubmit}>
          <span>Add Feature Flags:</span>
          <ReactMultiEmail
            placeholder=""
            emails={flags}
            onChange={(_flags) => {
              this.setState({ flags: _flags });
            }}
            validateEmail={(email) => true}
            getLabel={(
              flag,
              index,
              removeEmail,
            ) => (
              <div data-tag key={index}>
                {flag}
                <span data-tag-handle onClick={() => removeEmail(index)}> × </span>
              </div>
            )}
          />
        </Form>
        <br />
      </div>
    );
  }
}

FeaturePicker.propTypes = {
  onComplete: PropTypes.func.isRequired,
};

export default FeaturePicker;
